var map = {
	"./1-1.solution.json": 4793,
	"./1-10.solution.json": 9529,
	"./1-11.solution.json": 5716,
	"./1-2.solution.json": 3278,
	"./1-3.solution.json": 2739,
	"./1-4.solution.json": 2776,
	"./1-5.solution.json": 109,
	"./1-6.solution.json": 7938,
	"./1-7.solution.json": 4967,
	"./1-8.solution.json": 9932,
	"./1-9.solution.json": 1649,
	"./2-1.solution.json": 8358,
	"./2-2.solution.json": 8961,
	"./2-3.solution.json": 5516,
	"./2-4.solution.json": 4399,
	"./2-5.solution.json": 202,
	"./2-6.solution.json": 6149,
	"./sandbox.solution.json": 9395
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3435;